import { cn } from 'utils/cn';
import { CropTableProps } from 'utils/types';

import duplicateIcon from '/duplicate.svg';
import editIcon from '/editCrop.svg';
import deleteIcon from '/deleteCrop.svg';

const ActionButton = ({
  icon,
  onClick,
  disabled,
  tooltipId,
  className,
}: {
  icon: string;
  onClick: () => void;
  disabled: boolean;
  tooltipId: string;
  className?: string;
}) => (
  <img
    src={icon}
    alt=""
    className={cn(
      'w-[18px]',
      {
        'cursor-pointer': !disabled,
        'cursor-not-allowed': disabled,
      },
      className,
    )}
    onClick={disabled ? () => {} : onClick}
    data-tooltip-id={tooltipId}
  />
);

export const ActionButtons = ({
  data,
  disabled,
  tableDataLength,
  onDuplicate,
  onEdit,
  onDelete,
}: {
  data: CropTableProps;
  disabled: boolean;
  tableDataLength: number;
  onDuplicate: (id: number) => void;
  onEdit: (value: CropTableProps) => void;
  onDelete: (id: number) => void;
}) => (
  <div className="flex items-center">
    {tableDataLength < 10 && (
      <ActionButton
        icon={duplicateIcon}
        onClick={() => onDuplicate(data.id)}
        disabled={disabled}
        tooltipId="duplicate"
        className="mr-2"
      />
    )}

    <ActionButton
      icon={editIcon}
      onClick={() => onEdit(data)}
      disabled={disabled}
      tooltipId="edit"
      className="mr-2"
    />

    {tableDataLength > 1 && (
      <ActionButton
        icon={deleteIcon}
        onClick={() => onDelete(data.id)}
        disabled={disabled}
        tooltipId="delete"
      />
    )}
  </div>
);
